import React, { useState, useCallback, useEffect } from 'react';
import { TemplatesSidebar, TemplateEditor } from '../features/templates';
import { BoardTemplate, adminTemplateService } from '../lib/api/templates';

const TemplateStudioPage: React.FC = () => {
    const [selectedTemplate, setSelectedTemplate] = useState<BoardTemplate | null>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleCreateTemplate = async () => {
        try {
            const newTemplate = await adminTemplateService.createTemplate({
                name: 'Untitled Template',
                templateType: 'Other'
            });
            setSelectedTemplate(newTemplate);
            // Trigger sidebar refresh
            setRefreshTrigger((prev: number) => prev + 1);
        } catch (error) {
            console.error('Error creating template:', error);
        }
    };

    const handleTemplateUpdate = useCallback((updated: BoardTemplate) => {
        setSelectedTemplate(updated);
        // Trigger sidebar refresh to update the list
        setRefreshTrigger((prev: number) => prev + 1);
    }, []);

    const handleSelectTemplate = useCallback((template: BoardTemplate | null) => {
        setSelectedTemplate(template);
    }, []);



    const [isSidebarCollapsed, setSidebarCollapsed] = useState(() => {
        const stored = localStorage.getItem('templates-sidebar-collapsed');
        return stored ? JSON.parse(stored) : false;
    });

    useEffect(() => {
        localStorage.setItem('templates-sidebar-collapsed', JSON.stringify(isSidebarCollapsed));
    }, [isSidebarCollapsed]);

    const [isSidebarHovered, setSidebarHovered] = useState(false);

    // Determine effective display state
    const isOverlay = isSidebarCollapsed && isSidebarHovered;
    const showFullSidebar = !isSidebarCollapsed || isSidebarHovered;

    return (
        <div className="h-full flex">
            {/* Left Sidebar - Template List */}
            <div
                className={`flex-shrink-0 transition-all duration-300 relative z-20 bg-white border-r border-neutral-200 ${isSidebarCollapsed ? "w-16" : "w-72"
                    }`}
                onMouseEnter={() => isSidebarCollapsed && setSidebarHovered(true)}
                onMouseLeave={() => setSidebarHovered(false)}
            >
                <div className={`h-full transition-all duration-300 ${isOverlay ? "absolute top-0 left-0 w-72 shadow-xl z-50 h-full" : "w-full"
                    }`}>
                    <TemplatesSidebar
                        selectedTemplateId={selectedTemplate?.id || null}
                        onSelectTemplate={handleSelectTemplate}
                        onCreateTemplate={handleCreateTemplate}
                        refreshTrigger={refreshTrigger}
                        isCollapsed={!showFullSidebar}
                        isOverlay={isOverlay}
                        onToggleCollapse={() => {
                            setSidebarCollapsed((prev: boolean) => !prev);
                            if (isSidebarCollapsed) setSidebarHovered(false);
                        }}
                    />
                </div>
            </div>

            {/* Right - Template Editor */}
            <div className="flex-1 min-w-0">
                <TemplateEditor
                    template={selectedTemplate}
                    onTemplateUpdate={handleTemplateUpdate}
                />
            </div>
        </div>
    );
};

export { TemplateStudioPage };
